import React, { useEffect, useState } from "react";
import { TextField } from "@mui/material";
import BadgeOutlinedIcon from "@mui/icons-material/BadgeOutlined";
import { ReportGenUser } from "../../../shared/interfaces/User";
import { ADD_USER_BADGE_PATTERN } from "../../../shared/utils/userValidation";
import { ConfirmDialog } from "../../../shared/ui";

export interface EditBadgeDialogProps {
  open: boolean;
  user: ReportGenUser | null;
  isSaving: boolean;
  onClose: () => void;
  onSave: (badgeNumber: string) => void;
}

const EditBadgeDialog: React.FC<EditBadgeDialogProps> = ({
  open,
  user,
  isSaving,
  onClose,
  onSave,
}) => {
  const [badgeNumber, setBadgeNumber] = useState("");
  const [touched, setTouched] = useState(false);

  // Re-seed from the row each time the dialog opens for a user.
  useEffect(() => {
    if (open) {
      setBadgeNumber(user?.badgeNumber ?? "");
      setTouched(false);
    }
  }, [open, user]);

  const trimmed = badgeNumber.trim();
  const isValid = ADD_USER_BADGE_PATTERN.test(trimmed);

  return (
    <ConfirmDialog
      open={open}
      onClose={onClose}
      onConfirm={() => {
        setTouched(true);
        if (isValid && !isSaving) {
          onSave(trimmed);
        }
      }}
      icon={<BadgeOutlinedIcon />}
      iconVariant="tinted"
      title="Edit Badge Number"
      description={
        user
          ? `Update the badge number for ${[user.firstName, user.lastName].filter(Boolean).join(" ") || user.email}.`
          : undefined
      }
      confirmLabel="Save"
      loading={isSaving}
      confirmDisabled={!isValid}
    >
      <TextField
        fullWidth
        autoFocus
        label="Badge Number"
        value={badgeNumber}
        onChange={(e) => setBadgeNumber(e.target.value)}
        onBlur={() => setTouched(true)}
        error={touched && !isValid}
        helperText={
          touched && !isValid
            ? "Badge number must be 1 to 50 letters or digits"
            : " "
        }
        sx={{ mt: 2, "& .MuiOutlinedInput-root": { borderRadius: 2 } }}
      />
    </ConfirmDialog>
  );
};

export default EditBadgeDialog;
